<template>
  <div>
    <WebsiteHeader></WebsiteHeader>
    <v-row class="mt-16">
      <v-col :cols="isMobile ? 12 : 3" class="mt-10">
        <div>
          <v-row justify="space-around">
            <v-card width="400" color="#BDBDBD">
              <v-img
                height="200px"
                src="https://media.istockphoto.com/photos/phone-and-email-icons-on-wooden-cubes-with-contact-us-text-on-blue-picture-id1271752802?b=1&k=20&m=1271752802&s=170667a&w=0&h=sMEPVY49FAy2UHkhyQLWDHlAhYsR2F2NDkNlSEteO3s="
              >
              </v-img>

              <v-card-text>
                <div class="font-weight-bold ml-8 mb-2">
                  Our Branches / Offices
                </div>

                <v-timeline align-top dense>
                  <v-timeline-item :color="getThemeColor" small>
                    <div>
                      <div class="font-weight-normal">
                        <strong>{{ getUserCompany.name }}</strong>
                        <br />{{ getUserCompany.primary_address }} <br />{{
                          getUserCompany.postal_code
                        }}
                        <br />{{ getUserCompany.city }}
                        <br />
                        <br />{{ getUserCompany.primary_phone }} <br />
                      </div>
                      <div>{{ getUserCompany.email }}</div>
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-row>
        </div>
      </v-col>
      <v-col :cols="isMobile ? 12 : 9">
        <WebsiteContactUs class="mx-6 mt-6 mb-4"></WebsiteContactUs>
      </v-col>
    </v-row>
    <WebsiteFooter></WebsiteFooter>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import WebsiteContactUs from "@/components/SchoolWebsite/WebsiteContactUs.vue";

export default {
  components: { WebsiteHeader, WebsiteFooter, WebsiteContactUs },
  computed: {
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },

  mounted() {
    this.getAllBranches();
  },
  data: () => ({
    branches: [],
    colors: [
      "red lighten-1",
      "green",
      "deep-purple lighten-1",
      "teal",
      "primary",
    ],
  }),
  methods: {
    getAllBranches() {
      this.$store.commit("setLoader", true);
      axios
        .postData("/get-all-branches", {
          emis: this.getUserCompany.emis,
        })
        .then((branches) => {
          this.branches = branches;
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>
